import type { Retailer } from '../@types/Retailer';
import type Item from '../@types/item';
import { slugify } from '../helpers/urls';
import { withUser } from './tracker-with-user';

function getContactEmail(item: Item | null, retailer: Retailer) {
  if (!retailer) {
    return '';
  }

  const email = item?.contactOptions?.email;
  const defaultContactOptionsEmail = retailer?.defaultContactOptions?.email;

  return email || defaultContactOptionsEmail || '';
}

const getPhoneParams = (
  item: Item | null,
  retailer: Retailer | null,
  callback: (params: any) => void,
) => {
  if (item && retailer) {
    const parts: string[] = [];
    if (item.title) parts.push(item.title);

    if (item.shortDescription) parts.push(item.shortDescription);

    if (item.gearboxType) parts.push(item.gearboxType);

    withUser(null, (user) =>
      callback({
        custnr: retailer.id,
        custname: retailer.name,
        itemid: item.id,
        regno: item.registrationNumber,
        desc: item.shortDescription,
        isNew: user.isNew,
        cid: user.cid || '',
        unAuthId: user.unAuthId || '',
        userId: user.userId || '',
        contactEmail: getContactEmail(item, retailer),
        objectUrl: btoa(
          location.hostname.concat('/objekt/', item.id, '/', slugify(parts.join('-'))),
        ),
      }),
    );
  } else if (retailer) {
    withUser(null, (user) =>
      callback({
        custnr: retailer.id,
        custname: retailer.name,
        isNew: user.isNew,
        cid: user.cid || '',
        unAuthId: user.unAuthId || '',
        userId: user.userId || '',
        contactEmail: getContactEmail(null, retailer),
      }),
    );
  } else {
    callback({});
  }
};

export default getPhoneParams;
